import React, { FC } from 'react';
import cn from 'clsx';

import AppLink from '../AppLink';
import LazyImage from '../LazyImage';
import SlatButton from '../SlatButton';

import useMobile from '../../hooks/useMobile';

import { UNDERLINE_BUTTON_TYPE, BLACK_BUTTON_COLOR, LARGE_SIZE } from '../SlatButton';

const MasonryTile: FC<any> = ({
  backgroundColor,
  href,
  image,
  index,
  isMobile,
  mobileImage,
  title,
  tracking,
}) => {
  return (
    <AppLink
      className={cn('flex flex-col items-center', {
        'col-span-2': index === 0 || index === 3,
        'col-span-1': index === 1 || index === 2,
      })}
      href={href}
      tracking={tracking}
    >
      <div
        className="flex flex-col justify-between w-full h-full"
        style={{ backgroundColor: backgroundColor }}
      >
        {isMobile === false && (
          <div className="mt-12 mx-4 mb-3 text-center">
            <h3 className="heading-large xl:heading-xlarge 2xl:heading-xxlarge">{title}</h3>
            <SlatButton
              className="m-4 md:mb-6 whitespace-nowrap"
              color={BLACK_BUTTON_COLOR}
              href={href}
              size={LARGE_SIZE}
              tracking={tracking}
              type={UNDERLINE_BUTTON_TYPE}
            >
              Browse
            </SlatButton>
          </div>
        )}
        <LazyImage className="pt-6 lg:pt-0" image={isMobile ? mobileImage : image} />
      </div>
      {isMobile && (
        <SlatButton
          className="m-4 md:mb-0 whitespace-nowrap"
          color={BLACK_BUTTON_COLOR}
          href={href}
          tracking={tracking}
          type={UNDERLINE_BUTTON_TYPE}
        >
          {title}
        </SlatButton>
      )}
    </AppLink>
  );
};

const MasonryDisplay: FC<any> = ({ sections }) => {
  const isMobile = useMobile();

  return (
    <div className="grid grid-cols-2 lg:grid-cols-3 m-4 md:m-6 gap-4 md:gap-6 lg:mt-0 justify-items-stretch">
      {sections.map((ele: any, index: number) => (
        <MasonryTile key={ele.title} {...ele} index={index} isMobile={isMobile} />
      ))}
    </div>
  );
};

export default MasonryDisplay;
